import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/workflow-api/credit-allocation/page', params)
